module.exports = __webpack_public_path__ + "images/pages/for_business/pc/case2_e9ea23920ad3297881cf73a653cd5622.png";